// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aboutus_container {
  overflow: hidden;
}
.aboutus_banner_container {
  background-color: #140f2d;
  padding: 5px 50px 30px 50px;
}
.aboutus_banner_link_home {
  color: white;
  margin-right: 2px;
}
.aboutus_banner_link_home:hover {
  text-decoration: none;
}
.aboutus_banner_link_about {
  text-decoration: none;
  color: white;
  margin-left: 2px;
}
.aboutus_banner_link_arrow {
  color: white;
}
.aboutus_banner_heading {
  font-size: 25px;
  font-family: "Kufam";
  color: #ffffff;
  margin-top: 37px;
  font-weight: 700;
}
.aboutus_banner_content {
  color: #ffffff;
  font-family: "Lato";
  font-size: 23px;
  text-align: justify;
}
.aboutus_banner_content_ta {
  color: #ffffff;
  font-family: "Lato";
  font-size: 17px;
}
.our_mission_container {
  padding: 40px 60px 40px 60px;
  display: flex;
  gap: 10px;
}
.our_mission_left {
  width: 60%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.our_mission_left_inner {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.youturn_logo {
  width: clamp(240px, 80%, 600px);
}
.logo_content {
  color: #0065cc;
  font-size: 16px;
  text-align: center;
  padding-top: 15px;
}
.our_mission_right {
  width: 40%;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
}
.our_mission_right_heading {
  font-size: 22px;
  font-family: "Kufam";
  font-weight: 800;
}
.our_mission_right_content {
  font-size: 14px;
  font-family: "Lato";
  text-align: justify;
}
.our_mission_rightmeet_the_team_right_para {
  text-align: justify;
}
.meet_the_team_container {
  padding: 30px 50px 30px 50px;
  background: linear-gradient(115deg, #111a42 10%, #f49d36 280%);
}
.meet_the_team_head {
  display: flex;
  color: white;
  gap: 20px;
}
.button_img {
  height: 20px;
  margin-bottom: 2px;
}
.meet_the_team_heading {
  width: 35%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  font-family: "Kufam";
  font-weight: 700;
}
.meet_the_team_right_content {
  width: 65%;
  font-size: 15px;
  font-family: "Lato";
}
.team_members_image {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-row-gap: 50px;
  place-items: center;
}
.medical_expert_image {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-row-gap: 50px;
  place-items: center;
}
.team_member_container {
  color: white;
  position: relative;
  cursor: pointer;
}

.team_member_image {
  height: 190px;
  width: 190px;
  margin: 20px 0px;
}
.team_member_description {
  width: 190px;
  height: 40px;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  bottom: 13px;
  right: -60px;
  background: white;
  color: black;
  border-radius: 5px;
  z-index: 10;
}
.team_member_name {
  margin: 0;
  padding: 0;
}
.team_member_name {
  font-size: 11px;
  font-family: "Kufam";
  align-content: center;
  font-weight: 700;
}
.team_member_position {
  font-size: 10px;
  font-family: "Kufam";
  font-style: italic;
  align-content: center;
  margin: 0;
}
.medical_expert_heading {
  font-family: "Kufam";
  color: white;
  font-size: 32px;
  margin: 35px 0;
}
.medical_expert_container {
  padding-bottom: 30px;
}
.policies_container {
  padding: 0px 60px 0 60px;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 50px;
}
.policies_head {
  display: flex;
  gap: 40px;
  margin-top: 60px;
  padding: 30px 50px 30px 50px;
}
.ifcn_container {
  display: flex;
  gap: 40px;
}
.ifcn_heading {
  font-family: "Kufam";
  font-weight: 700;
  font-size: 20px;
}
.ifcn_description {
  font-size: 15px;
  text-align: justify;
}
.ifcn_image_desktop {
  color: #140f2d;
  height: 300px;
  object-fit: contain;
}
.ifcn_image_mobile {
  display: none;
}
.public_spirited_image_mobile {
  display: none;
}
.icnf_certificate {
  display: none;
}
.fight_fake_news_container {
  line-height: 1.3;
  margin-top: 7px;
  width: 35%;
  background-color: #140f2d;
  border-radius: 12px;
  color: white;
}
.fight_fake_news_container_mob {
  display: none;
}
.fight_fake_news_head {
  font-family: Lato;
  font-size: 11px;
  text-align: justify;
  margin: 0;
  padding: 0;
  height: auto;
}
.fight_fake_news_div {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  width: auto;
  color: #f49d36;
}
.fight_fake_news_hash {
  font-size: 70px;
  margin: 0;
}
.fight_fake_news_hash_val {
  font-size: 35px;
  font-family: "Kufam";
  line-height: 1;
  margin: 5px 0;
  text-wrap: wrap;
  font-weight: 800;
}
.fight_fake_news_second_div {
  display: flex;
  align-items: center;
  gap: 20px;
}
.figh_fake_news_button {
  width: 60%;
  height: 35px;
  border-radius: 8px;
  background-color: #0065cd;
  color: white;
  border: none;
}
.figh_fake_news_note {
  width: 30%;
  font-family: Lato;
  font-size: 10px;
  text-align: justify;
  margin: 0;
  padding: 0;
}

.policies_heading {
  font-family: "Kufam";
  font-weight: 700;
  font-size: 38px;
  margin: 20px 0;
}
.policies_button_div {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.policies_button {
  width: 45%;
  height: 42px;
  gap: 10px;
  border-radius: 5px;
  border: 1px solid #0065cc;
  background: white;
  color: #0065cc;
}
.icnf_button {
  width: 45%;
  height: 42px;
  gap: 10px;
  border-radius: 5px;
  border: 1px solid #0065cc;
  background: white;
  color: #0065cc;
}
.fight_fake_news_mod {
  display: none;
}
.fact_check_heading_mob {
  display: none;
  font-size: 15px;
  font-family: "lato";
  margin-bottom: 5px;
  font-weight: 800;
}
.fact_check_heading_dt {
  font-size: 15px;
  font-family: "lato";
  margin-bottom: 5px;
  font-weight: 800;
}
.fact_check_div {
  display: flex;
  justify-content: space-between;
  gap: 50px;
}
.fact_check_div_mob {
  display: flex;
}

.fact_check_divs {
  display: flex;
  width: 45%;
  gap: 15px;
  box-shadow: 1px 1px 10px rgb(189, 186, 186);
  padding: 15px;
  align-items: center;
  justify-content: center;
}
.fact_check_image {
  height: 110px;
  width: 110px;
}
.fact_check_heading {
  font-size: 15px;
  font-family: "lato";
  margin-bottom: 5px;
  font-weight: 800;
}
.fact_check_description {
  font-size: 12px;
  font-family: "lato";
  font-weight: 700;
}
.what_we_check_div {
  display: flex;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  align-items: center;
  justify-content: space-between;
  gap: auto;
}
.what_we_check_items {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 1px 1px 10px rgb(189, 186, 186);
  padding: 20px;
  width: 175px;
  height: 175px;
  cursor: pointer;
}
.what_we_check_text {
  text-align: center;
  font-family: "lato";
  font-weight: 700;
  margin-top: 10px;
}
.what_we_check_content {
  font-size: 10px;
}
.what_we_check_img {
  padding-top: 10px;
}
.fact_check_category_div {
  position: relative;
}
.share_circle {
  height: 500px;
  width: 500px;
  background: linear-gradient(180deg, #111a42 10%, #f49d36 280%);
  border-radius: 50%;
  position: absolute;
  top: -85px;
  right: -380px;
}
.fact_check_items_container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 80%;
  gap: 25px;
  margin: 0;
  padding: 0;
}
.fact_check_item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
}
.fact_check_image_one {
  height: 110px;
  width: 110px;
  margin-right: 19px;
}
.fact_check_description_one {
  font-size: 11px;
  min-height: 85px;
  width: 290px;
  padding-right: 12px;
  border: 1px solid #a1a1a1;
  margin: 0;
  margin-left: -20px;
  border-left: none;
  border-top-right-radius: 40px;
  border-bottom-right-radius: 40px;
  display: flex;
  align-items: center;
}
.circle_share_one {
  position: relative;
  top: 50px;
  left: 130px;
  height: 35px;
  cursor: pointer;
}
.circle_share_two {
  position: relative;
  top: 100px;
  left: 35px;
  height: 35px;
  cursor: pointer;
}
.circle_share_three {
  position: relative;
  top: 170px;
  left: -35px;
  height: 35px;
  cursor: pointer;
}
.circle_share_four {
  position: relative;
  top: 200px;
  left: 45px;
  height: 35px;
  cursor: pointer;
}
.circle_share_five {
  position: relative;
  top: 270px;
  left: 45px;
  height: 35px;
  cursor: pointer;
}
.circle_share_six {
  position: relative;
  top: 320px;
  left: 68px;
  height: 35px;
  cursor: pointer;
}
.circle_share_text {
  position: relative;
  top: 180px;
  left: 20px;
  color: white;
  font-family: "lato";
  width: 150px;
}
.circle_share_text_heading {
  margin: 0;
  font-size: 12px;
}
.circle_share_text_heading_ta {
  margin: 0;
  font-size: 13px;
}
.circle_share_text_description {
  margin: 0;
  font-size: 17px;
  text-wrap: wrap;
  font-weight: 700;
}
.circle_share_text_description_ta {
  margin: 0;
  font-size: 16px;
  text-wrap: wrap;
  font-weight: 700;
}
.stay_connect_mobile {
  display: none;
}
.policies_button_div_funding {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
}
.funding_container {
  display: flex;
  align-items: start;
  gap: 20px;
}
.funding_button {
  width: 100%;
  border-radius: 5px;
  border: 1px solid #0065cc;
  background: white;
  color: #0065cc;
}
.policies_description {
  font-family: "lato";
}
.funding_container_left {
  width: 40%;
  margin: 0;
  padding: 0;
}
.funding_container_right {
  width: 60%;
  background-color: #140f2d;
  margin: 40px 30px 20px;
  padding: 20px 40px;
  border-radius: 12px;
}
.funding_head {
  font-family: "Kufam";
  font-weight: 700;
  font-size: 38px;
  margin: 0px 0;
}
.funding_right_head {
  color: white;
  font-size: 13px;
  margin-bottom: 0;
}
.fight_fake_news_funding_div {
  display: flex;
  align-items: center;
  justify-content: start;
  margin: 0;
  padding: 0;
  color: #f49d36;
}
.fight_fake_news_funding_hash {
  font-size: 70px;
  margin: 0;
}
.fight_fake_news_funding_hash_val {
  font-size: 35px;
  font-family: "Kufam";
  line-height: 1;
  margin: 0;
}
.funding_right_note {
  display: flex;
  color: white;
  align-items: center;
  justify-content: space-between;
}
.funding_right_note_one {
  width: 65%;
  font-size: 15px;
  font-weight: 700;
}
.funding_right_note_two {
  width: 35%;
  font-size: 10px;
  font-weight: 300;
}
.funding_amount_div {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.funding_amount_button {
  width: 28%;
  height: 35px;
  background: white;
  border: none;
  border-radius: 8px;
}
.selected_funding_amount_button {
  width: 28%;
  height: 35px;
  background: #00acee;
  border: none;
  border-radius: 8px;
  color: white;
}

.funding_amount_button:hover {
  border: 2px solid #0065cc;
}
.funding_enter_amount_div {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.funding_enter_amount_button {
  width: 100%;
  height: 35px;
  background: white;
  border: none;
  border-radius: 8px;
  text-align: left;
  padding-left: 10px;
}
.funding_enter_amount_button::-webkit-inner-spin-button,
.funding_enter_amount_button::-webkit-outer-spin-button {
  -webkit-appearance: none;
}
.funding_enter_amount_button:focus {
  outline: none;
}
.funding_enter_amount_button:hover {
  border: 2px solid #0065cc;
}
.funding_donate_button {
  width: 100%;
  height: 35px;
  border-radius: 8px;
  background-color: #0065cd !important;
  color: white !important;
  border: none;
}
.award_list_container {
  padding: 30px 50px 0 50px;
  background: linear-gradient(115deg, #111a42 10%, #f49d36 280%);
  color: white;
}
.award_list_container_mob {
  display: none;
}
.award_list_div {
  display: flex;
  gap: 30px;
}
.award_list_one {
  width: 50%;
}
.award_list_two {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.award_list_two_img {
  height: 26vh;
}
.award_list_one_description {
  font-size: 18px;
  font-family: "Lato";
}
.award_list_one_content {
  font-size: 12px;
  margin-bottom: 10px;
}
.award_list_one_link {
  color: white;
}
.award_list_item_container {
  display: flex;
  margin: 40px 0;
  overflow: scroll;
}
.award_list_item_container::-webkit-scrollbar {
  display: none;
}
.award_list_image {
  width: 270px;
}
.become_a_member_div {
  margin: 50px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.become_a_member_heading {
  font-family: "lato";
  font-weight: 400;
  font-size: 24px;
}
.become_a_member_description {
  font-family: "lato";
  font-weight: 700;
  font-size: 36px;
  text-align: center;
}
.become_a_member_button {
  border-radius: 8px;
  background-color: var(--become-member-button);
  color: white;
  border: none;
  margin-top: 5px;
  height: auto;
}
.become_a_member_button:hover {
  background-color: var(--become-member-button);
}
.team_member_details_container {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 30px;
  border: 1px solid #ffb037;
  border-radius: 10px;
  align-items: center;
  margin-bottom: 40px;
}
.team_members_details {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.team_members_body_container {
  width: 95%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 22px;
}
.person_name_details {
  text-align: justify;
  color: white;
}
.person_name,
.social_media_title {
  color: white;
}
.team_member_details_body_mobile_container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.team_member_name_mobile,
.team_member_description_mobile {
  color: white;
  font-family: Lato;
}

.team_member_details_mobile_container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.carousel-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.social_media_mobile_container {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
.mobile_social_icon {
  width: 30px;
}

.policy-container {
  padding: 50px;
  font-family: Lato;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.policy-container h1 {
  text-align: start;
  font-size: 2em;
  margin-bottom: 20px;
  font-family: Lato;
  font-weight: 600;
}

.policy-container p {
  text-align: justify;
  margin-bottom: 10px;
}

.policy-container ol {
  padding-left: 20px;
}

.policy-container li {
  margin-bottom: 10px;
}
.corrections-policy {
  padding: 50px;
  margin: auto;
  font-family: Lato;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.corrections-policy h1 {
  font-size: 2em;
  text-align: start;
  font-family: Lato;
  font-weight: 600;
}

.corrections-policy p {
  font-size: 1em;
  line-height: 1.5em;
  margin: 10px 0;
  font-family: Lato;
}

.corrections-policy ol {
  margin-left: 20px;
  font-family: Lato;
}

.corrections-policy li {
  font-family: Lato;
  margin: 10px 0;
}
.ifcn_main_container {
  width: 65%;
  display: flex;
  flex-direction: column;
}
.ifcn_image,
.ifcn_image_desktop {
  cursor: pointer;
}
.team_members_profile {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 40px;
  min-width: 145px;
  max-width: 300px;
  background-color: white;
  margin-left: 20px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 8px;
  border-radius: 2px;
  z-index: 2;
  margin-top: 153px;
}

.profile_img {
  height: 172px;
  width: 172px;
  border-radius: 9px;
  z-index: 1;
  box-shadow: rgba(0, 101, 204, 0.4) 0px 3px 8px;
  object-fit: cover;
  pointer-events: none;
  cursor: pointer;
  padding: 2px;
}
.profile_card_container {
  position: relative;
  height: 202px;
  width: 202px;
}
.profile_name {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 11px;
  font-weight: 700;
  line-height: 14.2px;
  margin-top: 8px;
}
.profile_role {
  display: flex;
  justify-content: center;
  font-weight: 500;
  font-style: italic;
  font-size: 10px;
  line-height: 15.6px;
}
.profile_role_container {
  height: 20px;
  min-width: 190px;
  max-width: 300px;
}

.profile_name_container {
  height: 20px;
  min-width: 190px;
  max-width: 300px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout/user_aboutus.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,aAAa;EACb,SAAS;AACX;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,8DAA8D;AAChE;AACA;EACE,aAAa;EACb,YAAY;EACZ,SAAS;AACX;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sCAAsC;EACtC,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sCAAsC;EACtC,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,YAAY;AACd;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,WAAW;EACX,cAAc;AAChB;AACA;EACE,eAAe;EACf,SAAS;AACX;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,UAAU;EACV,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,UAAU;EACV,SAAS;EACT,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,aAAa;EACb,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,YAAY;EACZ,8DAA8D;EAC9D,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,UAAU;EACV,SAAS;EACT,SAAS;EACT,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,gCAAgC;EAChC,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE,SAAS;EACT,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,SAAS;EACT,UAAU;AACZ;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;AAChB;AACA;EACE,eAAe;EACf,SAAS;AACX;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,SAAS;AACX;AACA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,8DAA8D;EAC9D,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,YAAY;AACd;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;;EAEE,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;;EAEE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,0CAA0C;EAC1C,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,8CAA8C;EAC9C,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".aboutus_container {\r\n  overflow: hidden;\r\n}\r\n.aboutus_banner_container {\r\n  background-color: #140f2d;\r\n  padding: 5px 50px 30px 50px;\r\n}\r\n.aboutus_banner_link_home {\r\n  color: white;\r\n  margin-right: 2px;\r\n}\r\n.aboutus_banner_link_home:hover {\r\n  text-decoration: none;\r\n}\r\n.aboutus_banner_link_about {\r\n  text-decoration: none;\r\n  color: white;\r\n  margin-left: 2px;\r\n}\r\n.aboutus_banner_link_arrow {\r\n  color: white;\r\n}\r\n.aboutus_banner_heading {\r\n  font-size: 25px;\r\n  font-family: \"Kufam\";\r\n  color: #ffffff;\r\n  margin-top: 37px;\r\n  font-weight: 700;\r\n}\r\n.aboutus_banner_content {\r\n  color: #ffffff;\r\n  font-family: \"Lato\";\r\n  font-size: 23px;\r\n  text-align: justify;\r\n}\r\n.aboutus_banner_content_ta {\r\n  color: #ffffff;\r\n  font-family: \"Lato\";\r\n  font-size: 17px;\r\n}\r\n.our_mission_container {\r\n  padding: 40px 60px 40px 60px;\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n.our_mission_left {\r\n  width: 60%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.our_mission_left_inner {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n.youturn_logo {\r\n  width: clamp(240px, 80%, 600px);\r\n}\r\n.logo_content {\r\n  color: #0065cc;\r\n  font-size: 16px;\r\n  text-align: center;\r\n  padding-top: 15px;\r\n}\r\n.our_mission_right {\r\n  width: 40%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: start;\r\n  justify-content: center;\r\n}\r\n.our_mission_right_heading {\r\n  font-size: 22px;\r\n  font-family: \"Kufam\";\r\n  font-weight: 800;\r\n}\r\n.our_mission_right_content {\r\n  font-size: 14px;\r\n  font-family: \"Lato\";\r\n  text-align: justify;\r\n}\r\n.our_mission_rightmeet_the_team_right_para {\r\n  text-align: justify;\r\n}\r\n.meet_the_team_container {\r\n  padding: 30px 50px 30px 50px;\r\n  background: linear-gradient(115deg, #111a42 10%, #f49d36 280%);\r\n}\r\n.meet_the_team_head {\r\n  display: flex;\r\n  color: white;\r\n  gap: 20px;\r\n}\r\n.button_img {\r\n  height: 20px;\r\n  margin-bottom: 2px;\r\n}\r\n.meet_the_team_heading {\r\n  width: 35%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 40px;\r\n  font-family: \"Kufam\";\r\n  font-weight: 700;\r\n}\r\n.meet_the_team_right_content {\r\n  width: 65%;\r\n  font-size: 15px;\r\n  font-family: \"Lato\";\r\n}\r\n.team_members_image {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr 1fr 1fr;\r\n  grid-template-rows: 1fr 1fr;\r\n  grid-row-gap: 50px;\r\n  place-items: center;\r\n}\r\n.medical_expert_image {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr 1fr 1fr;\r\n  grid-row-gap: 50px;\r\n  place-items: center;\r\n}\r\n.team_member_container {\r\n  color: white;\r\n  position: relative;\r\n  cursor: pointer;\r\n}\r\n\r\n.team_member_image {\r\n  height: 190px;\r\n  width: 190px;\r\n  margin: 20px 0px;\r\n}\r\n.team_member_description {\r\n  width: 190px;\r\n  height: 40px;\r\n  position: absolute;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  bottom: 13px;\r\n  right: -60px;\r\n  background: white;\r\n  color: black;\r\n  border-radius: 5px;\r\n  z-index: 10;\r\n}\r\n.team_member_name {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n.team_member_name {\r\n  font-size: 11px;\r\n  font-family: \"Kufam\";\r\n  align-content: center;\r\n  font-weight: 700;\r\n}\r\n.team_member_position {\r\n  font-size: 10px;\r\n  font-family: \"Kufam\";\r\n  font-style: italic;\r\n  align-content: center;\r\n  margin: 0;\r\n}\r\n.medical_expert_heading {\r\n  font-family: \"Kufam\";\r\n  color: white;\r\n  font-size: 32px;\r\n  margin: 35px 0;\r\n}\r\n.medical_expert_container {\r\n  padding-bottom: 30px;\r\n}\r\n.policies_container {\r\n  padding: 0px 60px 0 60px;\r\n  margin-top: 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 50px;\r\n}\r\n.policies_head {\r\n  display: flex;\r\n  gap: 40px;\r\n  margin-top: 60px;\r\n  padding: 30px 50px 30px 50px;\r\n}\r\n.ifcn_container {\r\n  display: flex;\r\n  gap: 40px;\r\n}\r\n.ifcn_heading {\r\n  font-family: \"Kufam\";\r\n  font-weight: 700;\r\n  font-size: 20px;\r\n}\r\n.ifcn_description {\r\n  font-size: 15px;\r\n  text-align: justify;\r\n}\r\n.ifcn_image_desktop {\r\n  color: #140f2d;\r\n  height: 300px;\r\n  object-fit: contain;\r\n}\r\n.ifcn_image_mobile {\r\n  display: none;\r\n}\r\n.public_spirited_image_mobile {\r\n  display: none;\r\n}\r\n.icnf_certificate {\r\n  display: none;\r\n}\r\n.fight_fake_news_container {\r\n  line-height: 1.3;\r\n  margin-top: 7px;\r\n  width: 35%;\r\n  background-color: #140f2d;\r\n  border-radius: 12px;\r\n  color: white;\r\n}\r\n.fight_fake_news_container_mob {\r\n  display: none;\r\n}\r\n.fight_fake_news_head {\r\n  font-family: Lato;\r\n  font-size: 11px;\r\n  text-align: justify;\r\n  margin: 0;\r\n  padding: 0;\r\n  height: auto;\r\n}\r\n.fight_fake_news_div {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 0;\r\n  padding: 0;\r\n  width: auto;\r\n  color: #f49d36;\r\n}\r\n.fight_fake_news_hash {\r\n  font-size: 70px;\r\n  margin: 0;\r\n}\r\n.fight_fake_news_hash_val {\r\n  font-size: 35px;\r\n  font-family: \"Kufam\";\r\n  line-height: 1;\r\n  margin: 5px 0;\r\n  text-wrap: wrap;\r\n  font-weight: 800;\r\n}\r\n.fight_fake_news_second_div {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 20px;\r\n}\r\n.figh_fake_news_button {\r\n  width: 60%;\r\n  height: 35px;\r\n  border-radius: 8px;\r\n  background-color: #0065cd;\r\n  color: white;\r\n  border: none;\r\n}\r\n.figh_fake_news_note {\r\n  width: 30%;\r\n  font-family: Lato;\r\n  font-size: 10px;\r\n  text-align: justify;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.policies_heading {\r\n  font-family: \"Kufam\";\r\n  font-weight: 700;\r\n  font-size: 38px;\r\n  margin: 20px 0;\r\n}\r\n.policies_button_div {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n.policies_button {\r\n  width: 45%;\r\n  height: 42px;\r\n  gap: 10px;\r\n  border-radius: 5px;\r\n  border: 1px solid #0065cc;\r\n  background: white;\r\n  color: #0065cc;\r\n}\r\n.icnf_button {\r\n  width: 45%;\r\n  height: 42px;\r\n  gap: 10px;\r\n  border-radius: 5px;\r\n  border: 1px solid #0065cc;\r\n  background: white;\r\n  color: #0065cc;\r\n}\r\n.fight_fake_news_mod {\r\n  display: none;\r\n}\r\n.fact_check_heading_mob {\r\n  display: none;\r\n  font-size: 15px;\r\n  font-family: \"lato\";\r\n  margin-bottom: 5px;\r\n  font-weight: 800;\r\n}\r\n.fact_check_heading_dt {\r\n  font-size: 15px;\r\n  font-family: \"lato\";\r\n  margin-bottom: 5px;\r\n  font-weight: 800;\r\n}\r\n.fact_check_div {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 50px;\r\n}\r\n.fact_check_div_mob {\r\n  display: flex;\r\n}\r\n\r\n.fact_check_divs {\r\n  display: flex;\r\n  width: 45%;\r\n  gap: 15px;\r\n  box-shadow: 1px 1px 10px rgb(189, 186, 186);\r\n  padding: 15px;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.fact_check_image {\r\n  height: 110px;\r\n  width: 110px;\r\n}\r\n.fact_check_heading {\r\n  font-size: 15px;\r\n  font-family: \"lato\";\r\n  margin-bottom: 5px;\r\n  font-weight: 800;\r\n}\r\n.fact_check_description {\r\n  font-size: 12px;\r\n  font-family: \"lato\";\r\n  font-weight: 700;\r\n}\r\n.what_we_check_div {\r\n  display: flex;\r\n  grid-template-columns: 1fr 1fr 1fr 1fr;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: auto;\r\n}\r\n.what_we_check_items {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  box-shadow: 1px 1px 10px rgb(189, 186, 186);\r\n  padding: 20px;\r\n  width: 175px;\r\n  height: 175px;\r\n  cursor: pointer;\r\n}\r\n.what_we_check_text {\r\n  text-align: center;\r\n  font-family: \"lato\";\r\n  font-weight: 700;\r\n  margin-top: 10px;\r\n}\r\n.what_we_check_content {\r\n  font-size: 10px;\r\n}\r\n.what_we_check_img {\r\n  padding-top: 10px;\r\n}\r\n.fact_check_category_div {\r\n  position: relative;\r\n}\r\n.share_circle {\r\n  height: 500px;\r\n  width: 500px;\r\n  background: linear-gradient(180deg, #111a42 10%, #f49d36 280%);\r\n  border-radius: 50%;\r\n  position: absolute;\r\n  top: -85px;\r\n  right: -380px;\r\n}\r\n.fact_check_items_container {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  width: 80%;\r\n  gap: 25px;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n.fact_check_item {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 18px;\r\n}\r\n.fact_check_image_one {\r\n  height: 110px;\r\n  width: 110px;\r\n  margin-right: 19px;\r\n}\r\n.fact_check_description_one {\r\n  font-size: 11px;\r\n  min-height: 85px;\r\n  width: 290px;\r\n  padding-right: 12px;\r\n  border: 1px solid #a1a1a1;\r\n  margin: 0;\r\n  margin-left: -20px;\r\n  border-left: none;\r\n  border-top-right-radius: 40px;\r\n  border-bottom-right-radius: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.circle_share_one {\r\n  position: relative;\r\n  top: 50px;\r\n  left: 130px;\r\n  height: 35px;\r\n  cursor: pointer;\r\n}\r\n.circle_share_two {\r\n  position: relative;\r\n  top: 100px;\r\n  left: 35px;\r\n  height: 35px;\r\n  cursor: pointer;\r\n}\r\n.circle_share_three {\r\n  position: relative;\r\n  top: 170px;\r\n  left: -35px;\r\n  height: 35px;\r\n  cursor: pointer;\r\n}\r\n.circle_share_four {\r\n  position: relative;\r\n  top: 200px;\r\n  left: 45px;\r\n  height: 35px;\r\n  cursor: pointer;\r\n}\r\n.circle_share_five {\r\n  position: relative;\r\n  top: 270px;\r\n  left: 45px;\r\n  height: 35px;\r\n  cursor: pointer;\r\n}\r\n.circle_share_six {\r\n  position: relative;\r\n  top: 320px;\r\n  left: 68px;\r\n  height: 35px;\r\n  cursor: pointer;\r\n}\r\n.circle_share_text {\r\n  position: relative;\r\n  top: 180px;\r\n  left: 20px;\r\n  color: white;\r\n  font-family: \"lato\";\r\n  width: 150px;\r\n}\r\n.circle_share_text_heading {\r\n  margin: 0;\r\n  font-size: 12px;\r\n}\r\n.circle_share_text_heading_ta {\r\n  margin: 0;\r\n  font-size: 13px;\r\n}\r\n.circle_share_text_description {\r\n  margin: 0;\r\n  font-size: 17px;\r\n  text-wrap: wrap;\r\n  font-weight: 700;\r\n}\r\n.circle_share_text_description_ta {\r\n  margin: 0;\r\n  font-size: 16px;\r\n  text-wrap: wrap;\r\n  font-weight: 700;\r\n}\r\n.stay_connect_mobile {\r\n  display: none;\r\n}\r\n.policies_button_div_funding {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 20px;\r\n}\r\n.funding_container {\r\n  display: flex;\r\n  align-items: start;\r\n  gap: 20px;\r\n}\r\n.funding_button {\r\n  width: 100%;\r\n  border-radius: 5px;\r\n  border: 1px solid #0065cc;\r\n  background: white;\r\n  color: #0065cc;\r\n}\r\n.policies_description {\r\n  font-family: \"lato\";\r\n}\r\n.funding_container_left {\r\n  width: 40%;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n.funding_container_right {\r\n  width: 60%;\r\n  background-color: #140f2d;\r\n  margin: 40px 30px 20px;\r\n  padding: 20px 40px;\r\n  border-radius: 12px;\r\n}\r\n.funding_head {\r\n  font-family: \"Kufam\";\r\n  font-weight: 700;\r\n  font-size: 38px;\r\n  margin: 0px 0;\r\n}\r\n.funding_right_head {\r\n  color: white;\r\n  font-size: 13px;\r\n  margin-bottom: 0;\r\n}\r\n.fight_fake_news_funding_div {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: start;\r\n  margin: 0;\r\n  padding: 0;\r\n  color: #f49d36;\r\n}\r\n.fight_fake_news_funding_hash {\r\n  font-size: 70px;\r\n  margin: 0;\r\n}\r\n.fight_fake_news_funding_hash_val {\r\n  font-size: 35px;\r\n  font-family: \"Kufam\";\r\n  line-height: 1;\r\n  margin: 0;\r\n}\r\n.funding_right_note {\r\n  display: flex;\r\n  color: white;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n.funding_right_note_one {\r\n  width: 65%;\r\n  font-size: 15px;\r\n  font-weight: 700;\r\n}\r\n.funding_right_note_two {\r\n  width: 35%;\r\n  font-size: 10px;\r\n  font-weight: 300;\r\n}\r\n.funding_amount_div {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n.funding_amount_button {\r\n  width: 28%;\r\n  height: 35px;\r\n  background: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n}\r\n.selected_funding_amount_button {\r\n  width: 28%;\r\n  height: 35px;\r\n  background: #00acee;\r\n  border: none;\r\n  border-radius: 8px;\r\n  color: white;\r\n}\r\n\r\n.funding_amount_button:hover {\r\n  border: 2px solid #0065cc;\r\n}\r\n.funding_enter_amount_div {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-bottom: 20px;\r\n}\r\n.funding_enter_amount_button {\r\n  width: 100%;\r\n  height: 35px;\r\n  background: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  text-align: left;\r\n  padding-left: 10px;\r\n}\r\n.funding_enter_amount_button::-webkit-inner-spin-button,\r\n.funding_enter_amount_button::-webkit-outer-spin-button {\r\n  -webkit-appearance: none;\r\n}\r\n.funding_enter_amount_button:focus {\r\n  outline: none;\r\n}\r\n.funding_enter_amount_button:hover {\r\n  border: 2px solid #0065cc;\r\n}\r\n.funding_donate_button {\r\n  width: 100%;\r\n  height: 35px;\r\n  border-radius: 8px;\r\n  background-color: #0065cd !important;\r\n  color: white !important;\r\n  border: none;\r\n}\r\n.award_list_container {\r\n  padding: 30px 50px 0 50px;\r\n  background: linear-gradient(115deg, #111a42 10%, #f49d36 280%);\r\n  color: white;\r\n}\r\n.award_list_container_mob {\r\n  display: none;\r\n}\r\n.award_list_div {\r\n  display: flex;\r\n  gap: 30px;\r\n}\r\n.award_list_one {\r\n  width: 50%;\r\n}\r\n.award_list_two {\r\n  width: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.award_list_two_img {\r\n  height: 26vh;\r\n}\r\n.award_list_one_description {\r\n  font-size: 18px;\r\n  font-family: \"Lato\";\r\n}\r\n.award_list_one_content {\r\n  font-size: 12px;\r\n  margin-bottom: 10px;\r\n}\r\n.award_list_one_link {\r\n  color: white;\r\n}\r\n.award_list_item_container {\r\n  display: flex;\r\n  margin: 40px 0;\r\n  overflow: scroll;\r\n}\r\n.award_list_item_container::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n.award_list_image {\r\n  width: 270px;\r\n}\r\n.become_a_member_div {\r\n  margin: 50px 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.become_a_member_heading {\r\n  font-family: \"lato\";\r\n  font-weight: 400;\r\n  font-size: 24px;\r\n}\r\n.become_a_member_description {\r\n  font-family: \"lato\";\r\n  font-weight: 700;\r\n  font-size: 36px;\r\n  text-align: center;\r\n}\r\n.become_a_member_button {\r\n  border-radius: 8px;\r\n  background-color: var(--become-member-button);\r\n  color: white;\r\n  border: none;\r\n  margin-top: 5px;\r\n  height: auto;\r\n}\r\n.become_a_member_button:hover {\r\n  background-color: var(--become-member-button);\r\n}\r\n.team_member_details_container {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  padding: 30px;\r\n  border: 1px solid #ffb037;\r\n  border-radius: 10px;\r\n  align-items: center;\r\n  margin-bottom: 40px;\r\n}\r\n.team_members_details {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n.team_members_body_container {\r\n  width: 95%;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  gap: 22px;\r\n}\r\n.person_name_details {\r\n  text-align: justify;\r\n  color: white;\r\n}\r\n.person_name,\r\n.social_media_title {\r\n  color: white;\r\n}\r\n.team_member_details_body_mobile_container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n.team_member_name_mobile,\r\n.team_member_description_mobile {\r\n  color: white;\r\n  font-family: Lato;\r\n}\r\n\r\n.team_member_details_mobile_container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n.carousel-container {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.social_media_mobile_container {\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 10px;\r\n}\r\n.mobile_social_icon {\r\n  width: 30px;\r\n}\r\n\r\n.policy-container {\r\n  padding: 50px;\r\n  font-family: Lato;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n\r\n.policy-container h1 {\r\n  text-align: start;\r\n  font-size: 2em;\r\n  margin-bottom: 20px;\r\n  font-family: Lato;\r\n  font-weight: 600;\r\n}\r\n\r\n.policy-container p {\r\n  text-align: justify;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.policy-container ol {\r\n  padding-left: 20px;\r\n}\r\n\r\n.policy-container li {\r\n  margin-bottom: 10px;\r\n}\r\n.corrections-policy {\r\n  padding: 50px;\r\n  margin: auto;\r\n  font-family: Lato;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.corrections-policy h1 {\r\n  font-size: 2em;\r\n  text-align: start;\r\n  font-family: Lato;\r\n  font-weight: 600;\r\n}\r\n\r\n.corrections-policy p {\r\n  font-size: 1em;\r\n  line-height: 1.5em;\r\n  margin: 10px 0;\r\n  font-family: Lato;\r\n}\r\n\r\n.corrections-policy ol {\r\n  margin-left: 20px;\r\n  font-family: Lato;\r\n}\r\n\r\n.corrections-policy li {\r\n  font-family: Lato;\r\n  margin: 10px 0;\r\n}\r\n.ifcn_main_container {\r\n  width: 65%;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n.ifcn_image,\r\n.ifcn_image_desktop {\r\n  cursor: pointer;\r\n}\r\n.team_members_profile {\r\n  position: absolute;\r\n  top: 0px;\r\n  left: 0px;\r\n  height: 40px;\r\n  min-width: 145px;\r\n  max-width: 300px;\r\n  background-color: white;\r\n  margin-left: 20px;\r\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 8px;\r\n  border-radius: 2px;\r\n  z-index: 2;\r\n  margin-top: 153px;\r\n}\r\n\r\n.profile_img {\r\n  height: 172px;\r\n  width: 172px;\r\n  border-radius: 9px;\r\n  z-index: 1;\r\n  box-shadow: rgba(0, 101, 204, 0.4) 0px 3px 8px;\r\n  object-fit: cover;\r\n  pointer-events: none;\r\n  cursor: pointer;\r\n  padding: 2px;\r\n}\r\n.profile_card_container {\r\n  position: relative;\r\n  height: 202px;\r\n  width: 202px;\r\n}\r\n.profile_name {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  line-height: 14.2px;\r\n  margin-top: 8px;\r\n}\r\n.profile_role {\r\n  display: flex;\r\n  justify-content: center;\r\n  font-weight: 500;\r\n  font-style: italic;\r\n  font-size: 10px;\r\n  line-height: 15.6px;\r\n}\r\n.profile_role_container {\r\n  height: 20px;\r\n  min-width: 190px;\r\n  max-width: 300px;\r\n}\r\n\r\n.profile_name_container {\r\n  height: 20px;\r\n  min-width: 190px;\r\n  max-width: 300px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
